import script from "./black-listed-employee.vue?vue&type=script&lang=ts&setup=true"
export * from "./black-listed-employee.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__